export default (that) => [
  {
    text: that.$l('menu_text_detail') || '查看详情',
    icon: 'el-icon-view',
    menuType: 'detail',
  },
  {
    text: that.$l('menu_logistics_confirmation') || '推送物流确认',
    icon: 'el-icon-truck',
    menuType: 'confirmation',
    divided: true,
    allow: 'C',
    disabled: ({ replenishmentStatus }) => !['Y'].includes(replenishmentStatus),
  },
  {
    text: that.$l('menu_text_export') || '导出单据',
    icon: 'el-icon-right',
    menuType: 'export',
    divided: true,
    allow: 'E',
    disabled: ({ replenishmentStatus }) => !['Y', 'S'].includes(replenishmentStatus),
  },
  {
    text: that.$l('menu_FBA_export') || 'FBA出货计划导出',
    icon: 'el-icon-notebook-1',
    menuType: 'FBAExport',
    allow: 'P',
    disabled: ({ replenishmentStatus }) => !['S'].includes(replenishmentStatus),
  },
  {
    text: that.$l('menu_text_setFba') || '回填FBA信息',
    icon: 'el-icon-edit',
    menuType: 'set-scm-fba',
    divided: true,
    allow: 'S',
    disabled: ({ replenishmentStatus }) => !['Y', 'S'].includes(replenishmentStatus),
  },
  {
    text: that.$l('menu_text_buildShipment') || '生成发运单',
    icon: 'el-icon-document-add',
    menuType: 'buildShipment',
    allow: 'G',
    disabled: (row) => !that.canBuildShipment(row),
  },
]
